import React, { useMemo } from "react";

import { Executor } from "../../../../../../../services";
import { CellContentRoot } from "../../../../../../LightTable";
import { ExecutorInfo } from "../../../../../../common";

const AliasCellContent: React.FC<AliasCellContent.Props> = ({ item }) => {
	const _item: any = item;
	const content = useMemo(() => _item.speed ?? undefined, [_item.speed]);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<ExecutorInfo
				widgetType="Executors"
				id={item.id}
				executor={item}
				speed={content}
			/>
		</CellContentRoot>
	);
};

declare namespace AliasCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default React.memo(AliasCellContent);
